import './core/ui/assignmentNotifier';
import './core/ui/modalFocusManager';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './app/App';
import './styles/theme.css';
import './styles/app.css';
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<React.StrictMode><App /></React.StrictMode>);
